import { render, staticRenderFns } from "./PaginationV2.vue?vue&type=template&id=50349a50&"
import script from "./PaginationV2.vue?vue&type=script&lang=js&"
export * from "./PaginationV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports